export default "__VITE_ASSET__C$JvTyJf__"